import { render, staticRenderFns } from "./regTypeAutoFormDialog.vue?vue&type=template&id=2a3a27a6"
import script from "./regTypeAutoFormDialog.vue?vue&type=script&lang=js"
export * from "./regTypeAutoFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports